export default [
    {
        title: 'marketing.title',
        fontIcon: 'rectangle-ad',
        resource: 'Marketing',
        action: 'ver-marketing',
        children: [
            {
                title: 'Mantenimiento',
                icon: 'EditIcon',
                resource: 'Marketing',
                action: 'ver-marketing-mantenimiento',
                children: [
                    {
                        route: 'marketing-mantenimiento-bodega',
                        title: 'marketing.mantenimiento.bodega.title',
                        fontIcon: 'shop',
                        resource: 'Marketing',
                        action: 'ver-marketing-mantenimiento-bodega',
                    },
                    {
                        route: 'marketing-mantenimiento-categoria',
                        title: 'marketing.mantenimiento.categoria.title',
                        fontIcon: 'list',
                        resource: 'Marketing',
                        action: 'ver-marketing-mantenimiento-categoria',
                    },
                    {
                        route: 'marketing-mantenimiento-item',
                        title: 'marketing.mantenimiento.item.title',
                        fontIcon: 'box',
                        resource: 'Marketing',
                        action: 'ver-marketing-mantenimiento-item',
                    },
                ],
            },
            {
                title: 'Transacciones',
                fontIcon: 'exchange-alt',
                resource: 'Marketing',
                action: 'ver-marketing-transacciones',
                children: [
                    {
                        route: 'marketing-transacciones-inventario',
                        title: 'marketing.transacciones.inventario.title',
                        fontIcon: 'boxes-stacked',
                        resource: 'Marketing',
                        action: 'ver-marketing-transacciones-inventario',
                    },
                    {
                        route: 'marketing-transacciones-aprobar-egresos',
                        title: 'marketing.transacciones.aprobar-egresos.title',
                        fontIcon: 'clipboard-check',
                        resource: 'Marketing',
                        action: 'ver-marketing-transacciones-aprobar-egresos',
                    },
                ],
            },
            {
                title: 'Informes',
                fontIcon: 'file-prescription',
                resource: 'Marketing',
                action: 'ver-marketing-informes',
                children: [
                    {
                        route: 'marketing-informes-kardex',
                        title: 'marketing.informes.kardex.title',
                        fontIcon: 'boxes-stacked',
                        resource: 'Marketing',
                        action: 'ver-marketing-informes-kardex',
                    },
                ],
            },
        ],
    },
]
